import React from "react";
import classNames from "classnames";
import "../ThemeSwitcher/ThemeSwitcher.scss";

const SignInThemeSwitcher = (props) => {
  let switchClassName = classNames({
    switch: true,
    signin: true,
  });

  let sliderClassName = classNames({
    slider: true,
    round: true,
    signin: true,
  });

  return (
    <label id="switch" className={switchClassName}>
      <input
        className="signin"
        type="checkbox"
        checked={props.checked}
        onChange={props.onChange}
        id="slider"
      ></input>
      <span className={sliderClassName}></span>
    </label>
  );
};

export default SignInThemeSwitcher;
